import { render } from "./ReportPage.vue?vue&type=template&id=627f68e4&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"

import "./ReportPage.vue?vue&type=style&index=0&id=627f68e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627f68e4"]])

export default __exports__